<template>
  <DashboardMenu />
  <div class="container">
    <div class="row">
      <h1 class="h1">Прокси</h1>
    </div>

    <div class="mdc-card">
      <div class="mdc-card-wrapper__text-section">
        <div class="card__title">Список прокси</div>
      </div>
      <div class="mdc-data-table">
        <!-- <div class="card">
          <div class="card-body"> -->
        <div class="mdc-data-table__table-container">
          <table class="mdc-data-table__table">
            <thead>
              <tr class="mdc-data-table__header-row">
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Id Доноров
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Прокси
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Статус
                </th>
              </tr>
            </thead>
            <tbody class="mdc-data-table__content">
              <tr
                class="mdc-data-table__row"
                v-for="(donors, proxy) in proxyData"
                :key="proxy"
              >
                <th class="mdc-data-table__cell" scope="row">
                  <router-link v-for="(donorId, i) in donors" :key="donorId" :to="'/dashboard/donors/' + donorId">{{
                      donorId
                  }}{{ ++i === donors.length ? '' : ', '}} 
                  </router-link>
                </th>
                <td class="mdc-data-table__cell">{{ proxy }}</td>
                <td class="mdc-data-table__cell">
                  <span class="success" v-if="donors['status'] === 'LIVE'">LIVE</span>
                  <span class="error" v-else-if="donors['status'] === 'DEAD'">DEAD</span>
                  <span v-else>Unknown</span>
                  </td>
              </tr>
            </tbody>
          </table>
          <button class="mdc-button" @click="checkProxy">
          <span class="mdc-button__ripple"></span>
          <span class="mdc-button__label">Чекунть прокси</span>
        </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardMenu from '@/components/DashboardMenu.vue';

export default {
  data() {
    return {
      proxyData: []
    };
  },
  methods: {
    async getProxies() {
      try {
        const token = localStorage.getItem('adminAuthToken');
        const resp = await this.axios.get('donors/proxy', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        // console.log(resp);
        this.proxyData = resp.data.proxies;
      } catch (err) {
        // localStorage.removeItem('adminAuthToken');
        // console.log('fail')
        // console.log(err);
      }
    },
     async checkProxy() {
      try {
        const token = localStorage.getItem('adminAuthToken');
        const resp = await this.axios.get('donors/proxy/check', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        // console.log(resp);
        this.checkTime = resp.data.checkTime
        this.showToaster('Прокси чекнуты успешно за '+resp.data.checkTime+' с.');
        // console.log(resp.data)
        resp.data.response.forEach((value) => {
          this.proxyData[value.proxy].status = value.status
        })
        // console.log(this.proxyData)
        // this.proxyData = resp.data.response;
      } catch (err) {
        // localStorage.removeItem('adminAuthToken');
        // console.log('fail')
        // console.log(err);
      }
    },
    showToaster(msg) {
      this.$toast.show(msg, {
        position: 'top'
        // duration: false,
      });
    }
  },
  updated() {
    // console.log('proxyData: ' + this.proxyData);
  },
  mounted() {
    this.getProxies();
  },
  components: { DashboardMenu }
};
</script>

<style lang="scss" scoped>
@import '../styles/material-components-web.min.css';

.success { 
  color: green;
  font-weight: bold;
}

.error { 
  color: red;
  font-weight: bold;
}

.container {
  flex-direction: column;
  width: 1280px;
  max-width: 90%;
  margin: 0 auto;
}

.mdc-data-table__header-cell {
  height: 56px;
  font-weight: bold;
}

.stats-columns {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.stats-column {
  width: 25%;
  padding: 10px;
}

.mdc-card-wrapper__text-section {
  padding: 16px;
}

.card__title {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  text-decoration: inherit;
  text-transform: inherit;
}

.card__subhead {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  text-decoration: inherit;
  text-transform: inherit;
  opacity: 0.6;
}

.card__supporting-text {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  text-decoration: inherit;
  text-transform: inherit;
  opacity: 0.6;
}

.select-mode-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

select {
  padding: 8px 12px;
  border: 1px solid #333;
  opacity: 0.6;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.0178571429em;
}

.mdc-data-table__pagination-navigation a {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.47);
  font-size: 24px;
  cursor: pointer;
  &:hover {
    color: rgba(0, 0, 0, 0.87);
    transition: 0.3s all ease;
  }
}

.mdc-data-table__pagination-navigation .pagination-link-wrapper {
  margin-right: 5px;
  width: 48px;
  height: 48px;
  padding: 12px;
}

.mdc-data-table__pagination-navigation button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mdc-button {

    color: #333;
    border: 1px solid #333;
    width: 20%;
    display: flex;
    margin: 15px;
}
// .danger {
//   background: rgb(240, 128, 128, 0.7);
// }

// .success {
//   background: rgba(144, 238, 144, 0.7);
// }
</style>